import { useTranslation } from 'react-i18next';
import { useRootSelector } from '../../../../../store/hooks';

import { selectSiteHeader } from '../../../../../store/features/siteHeader';

import PaymentProvider from '../../../shared/PaymentProvider';
import Layout from '../../../shared/layouts/Layout';
import PageLayout from '../../../shared/layouts/PageLayout';
import { MetaTags } from '../../../../hub/shared/MetaTags';
import OrderNotFoundMessage from '../components/OrderNotFoundMessage';
import BookingClosedMessage from '../components/BookingClosedMessage';

export default function OrderNotFound() {
  const { t } = useTranslation();
  const {
    data: { booking },
  } = useRootSelector(selectSiteHeader);

  return (
    <PaymentProvider>
      <Layout disableUpperFooter>
        <MetaTags title={t('site.pricing.order-not-found')} />
        <PageLayout variant="full">
          {booking ? <OrderNotFoundMessage /> : <BookingClosedMessage />}
        </PageLayout>
      </Layout>
    </PaymentProvider>
  );
}
